import PostDataForm from "./post-data-form";

export default PostDataForm;